import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { Account } from '../types/account';

type GetChartOfAccountsResponse = {
    accounts: Account[];
    totalItems: number;
};

type UseChartOfAccountsConfig = {
    filterQuery?: string;
    searchQuery?: string;
    searchFilters?: string;
    sortQuery?: string;
    limit?: number;
    page: number;
};

async function getChartOfAccounts(
    workpaperId: string,
    { limit, page, filterQuery, searchQuery, sortQuery, searchFilters }: UseChartOfAccountsConfig
): Promise<GetChartOfAccountsResponse> {
    const { data } = await api.get(
        `/workpapers/${workpaperId}/accounts?${filterQuery}&search=${searchQuery}&${searchFilters}&${sortQuery}&limit=${limit}&page=${page}`
    );
    return data;
}

export function useChartOfAccounts({
    limit,
    page,
    filterQuery,
    searchQuery,
    sortQuery,
    searchFilters,
}: UseChartOfAccountsConfig): UseQueryResult<GetChartOfAccountsResponse, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useQuery(
        ['workpapers', workpaperId, 'accounts', limit, page, filterQuery, searchQuery, sortQuery, searchFilters],
        () => getChartOfAccounts(workpaperId, { limit, page, filterQuery, searchQuery, sortQuery, searchFilters }),
        {
            keepPreviousData: true,
            enabled: filterQuery !== undefined && searchQuery !== undefined && sortQuery !== undefined,
        }
    );
}
